import { db } from '../../app-firebase/firebase';
// import { storage } from '../../app-firebase/firebase';

export const GET_DATA = 'GET_DATA';
// export const ADD_TO_CART = 'ADD_TO_CART';

/**
 * Gets an instance of the firebase realtime database.
 * The use of the 'thunk' library allows this action creator to
 * return a middleware function that receives the dispatch()
 * method to be used as a callback, then it runs async code
 * (booksRef.on()) to later call its callback (dispatch()).
 * 
 * @param {object} payload The whole database object
 */
export const getDatabaseAction = () => {
   return (dispatch) => {
      db.ref().on('value', snap => {
         dispatch({
            type: GET_DATA,
            payload: snap.val()
         });
      });
   }
}

